<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <circle-icon></circle-icon>
          병해영상분석
        </CCardHeader>
        <CCardBody>
          <CRow v-if="analysis == null">
            <CCol md="12">
              <div class="disease-image-wrap dash">
                <div class="disease-image-help">
                  <div>분석 요청이미지를 선택하세요</div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow :class="analysis == null ? 'd-none' : ''">
            <CCol col="12" md="4">
              <div class="disease-image-wrap dash mb-4 mb-md-0">
                <div class="disease-image-box disease-image-label left-top bg-primary">원본</div>
                <div class="disease-image-box right-top">
                  <CButton color="danger" @click="clearImage"><i class="fa fa-times" aria-hidden="true"></i
                  ></CButton>
                </div>
                <div class="disease-image-preview">
                  <img :src="analysis.imageUrl" :class="getImageClass()" v-if="analysis" />
                </div>
              </div>
            </CCol>
            <CCol col="12" md="4">
              <div class="disease-image-wrap">
                <div class="disease-image-box disease-image-label left-top bg-primary">
                  주석도구
                </div>
                <div class="disease-image-box right-top" v-if="!drawing.isDrawing">
                  <CButton color="success" @click="changeDrawing('add')">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </CButton>

                  <div
                    class="popover-old bs-popover-old-auto fade show"
                    role="tooltip"
                    aria-hidden="false"
                    x-placement="bottom-end"
                    style="
                      min-width: 250px;
                      position: absolute;
                      transform: translate3d(-210px, 36px, 0px);
                      top: 0px;
                      left: 0px;
                      will-change: transform;
                    "
                    v-if="analysis != null && analysis.annotations.length === 0"
                  >
                    <div class="arrow" style="left: 215px"></div>
                    <div class="popover-old-body">이 버튼으로 주석을 추가할 수 있습니다.</div>
                  </div>
                </div>
                <div class="disease-image-box right-top" v-else>
                  <CButton
                    color="success mr-1"
                    @click="changeDrawing('confirm')"
                    v-if="drawing.width !== 0 || drawing.height !== 0"
                  >
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </CButton>
                  <CButton color="danger" @click="changeDrawing('cancel')">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </CButton>
                </div>
                <div class="disease-image-preview">
                  <canvas ref="canvas" :class="getImageClass()"></canvas>
                  <canvas
                    ref="drawingCanvas"
                    style="position: absolute"
                    :class="getImageClass()"
                    @mousedown="handleMouseDown"
                    @mousemove="handleMouseMove"
                    @mouseup="handleMouseUp"
                    @mouseout="handleMouseOut"
                  ></canvas>
                  <div
                    v-if="drawing.isDrawing"
                    style="
                      position: absolute;
                      z-index: 10;
                      background: rgba(0, 0, 0, 0.6);
                      padding: 5px 10px 5px 10px;
                      width: 100%;
                      text-align: center;
                      color: #ffffff;
                      bottom: -35px;
                    "
                  >
                    마우스를 드래그하여 영역을 그리세요!
                  </div>
                </div>
              </div>
            </CCol>
            <CCol
              class="h-100"
              col="12"
              md="4"
              v-if="analysis != null && analysis.annotations != null"
            >
              <CSelect
                label="분석결과"
                placeholder="분석 결과 선택하세요"
                horizontal
                :value.sync="resultStatus"
                :options="resultStatusList"
              >
              </CSelect>
              <div v-if="resultStatus === 'ANNOTATION'">
                <div v-if="analysis.annotations.length > 0">
                  <div
                    v-for="(item, i) in analysis.annotations"
                    :key="i"
                    class="input-group mt-2 mt-md-0 mb-2"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">{{ item.id }}</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="병해충명을 입력하세요"
                      v-model="item.name"
                    />
                    <div class="input-group-append">
                      <CButton color="danger" @click="removeAnnotation(item)">
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </CButton>
                    </div>
                  </div>
                </div>
                <div v-else class="mt-2 mt-md-0 mb-2">
                  <CAlert color="warning" fade> 추가된 주석이 없습니다.</CAlert>
                </div>
              </div>
              <div class="h-100">
                <CButton color="primary" @click="save()" class="w-100"> 저장</CButton>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import MixinStorage from "@/mixins/storage";
import core from "@/core";
import DiseaseService from "@/services/disease/disease.service";

export default {
  name: "DiseaseImageComponent",
  components: {},
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          cropCode: "",
          analysis: null,
          callback: null,
        };
      },
    },
  },
  mixins: [MixinStorage("disease")],
  data() {
    return {
      analysis: null,
      drawing: {
        isDrawing: false,
        isStarted: false,
        imageWidth: 0,
        imageHeight: 0,
        startX: 0,
        startY: 0,
        width: 0,
        height: 0,
      },
      popover: {
        addButton: {
          header: "Popover!",
          content: "이 버튼으로 주석을 추가할 수 있습니다.",
          active: true,
          placement: "bottom-end",
        },
      },
      resultStatus: "ANNOTATION",
      resultStatusList: [
        { label: "주석", value: "ANNOTATION" },
        { label: "병충해 없음", value: "NONE" },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {});
  },
  watch: {
    "properties.analysis"(analysis) {
      if (analysis != null) {
        //console.log("change analysis : ", JSON.stringify(analysis));
        const drawing = this.drawing;
        drawing.isDrawing = false;
        drawing.startX = 0;
        drawing.startY = 0;
        drawing.width = 0;
        drawing.height = 0;
        drawing.isStarted = false;
        drawing.imageWidth = 0;
        drawing.imageHeight = 0;

        if (analysis.annotations == null) analysis.annotations = [];
        this.analysis = core.utils.deepCopy(analysis);
        //console.log(this.analysis);

        this.changedAnalysis();
      }
    },
    "properties.cropCode"(cropCode) {
      console.log("cropCode : ", cropCode);
    },
    "drawing.isStarted"(isStarted) {
      if (!isStarted) {
        const drawing = this.drawing;
        if (drawing.width !== 0 || drawing.height !== 0) {
          this.changeDrawing("confirm");
        }
      }
    },
  },
  methods: {
    clearImage() {
      this.analysis = null;
      this.properties.analysis = null;
      this.changeDrawing("cancel");
    },
    getImageClass() {
      if (this.analysis != null && this.analysis.clazz != null) {
        return this.analysis.clazz;
      }
      return "";
    },
    changeDrawing(result) {
      const drawing = this.drawing;
      let isDrawing = false;
      if (result === "add") {
        isDrawing = true;
      } else if (result === "confirm") {
        // 추가
        this.addAnnotation();
      } else {
        if (drawing.isDrawing) {
          this.changedAnalysis();
        }
      }
      drawing.isDrawing = isDrawing;
      if (!isDrawing) {
        drawing.startX = 0;
        drawing.startY = 0;
        drawing.width = 0;
        drawing.height = 0;
      }
    },
    async save() {
      try {
        const analysis = this.analysis;

        const params = {
          resultStatus: this.resultStatus,
          annotations: [],
        };
        if (params.resultStatus === "ANNOTATION") {
          params.annotations = analysis.annotations;
        }
        const resultAnalysis = await DiseaseService.update(analysis.id, params);
        const propsAnalysis = this.properties.analysis;
        for (const key of Object.keys(resultAnalysis)) {
          propsAnalysis[key] = resultAnalysis[key];
        }
        this.properties.analysis = null;
        this.properties.analysis = propsAnalysis;
        await core.alert.show({
          title: "알림",
          body: "저장되었습니다",
        });

        if (this.resultStatus === "NONE") {
          this.clearImage();
          this.properties.callback = { type: "DELETE", item: propsAnalysis };
        }
      } catch (e) {
        console.log(e);
      }
    },
    removeAnnotation(item) {
      let index = null;
      const annotations = this.analysis.annotations;
      annotations.some((annotation, _index) => {
        if (annotation.id === item.id) {
          index = _index;
          return true;
        }
      });
      if (index != null) {
        annotations.splice(index, 1);
        annotations.forEach((annotation, _index) => {
          annotation.id = _index + 1;
        });
        console.log("changed annotations");
        this.changedAnalysis();
      } else {
        console.log("not found annotation index : ", index);
      }
      //console.log("annotation length : ", analysis.annotations.length);
    },
    addAnnotation() {
      const drawing = this.drawing;

      let id = 1;
      const annotations = this.analysis.annotations;
      annotations.forEach((annotation) => {
        id = annotation.id + 1;
      });

      const annotation = {
        id: id,
        name: "",
        minX: drawing.startX,
        minY: drawing.startY,
        maxX: drawing.startX + drawing.width,
        maxY: drawing.startY + drawing.height,
      };

      if (annotation.minX > annotation.maxX) {
        const temp = annotation.minX;
        annotation.minX = annotation.maxX;
        annotation.maxX = temp;
      }

      if (annotation.minY > annotation.maxY) {
        const temp = annotation.minY;
        annotation.minY = annotation.maxY;
        annotation.maxY = temp;
      }

      annotations.push(annotation);

      this.drawAnnotation(annotation);
    },
    getLineWidth() {
      const drawing = this.drawing;
      let maxSize = drawing.imageWidth;
      if (maxSize < drawing.imageHeight) {
        maxSize = drawing.imageHeight;
      }
      return parseInt(maxSize / 200);
    },
    getFontSize() {
      const drawing = this.drawing;
      let maxSize = drawing.imageWidth;
      if (maxSize < drawing.imageHeight) {
        maxSize = drawing.imageHeight;
      }
      return parseInt(maxSize / 20);
    },
    drawAnnotation(item) {
      const lineWidth = this.getLineWidth();
      const fontSize = this.getFontSize();

      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      ctx.strokeStyle = "black";
      ctx.fillStyle = "black";
      ctx.rect(item.minX, item.minY, item.maxX - item.minX, item.maxY - item.minY);
      ctx.lineWidth = lineWidth;
      ctx.stroke();
      ctx.font = fontSize + "px Arial";

      ctx.fillText("ID " + item.id, item.minX - (lineWidth + 1), item.minY - (lineWidth + 5));
    },
    changedAnalysis() {
      const analysis = this.analysis;
      const canvas = this.$refs.canvas;
      const drawingCanvas = this.$refs.drawingCanvas;
      const resultStatus = analysis.resultStatus;
      if (resultStatus === "ANNOTATION" || resultStatus === "NONE") {
        this.resultStatus = resultStatus;
      } else {
        this.resultStatus = "ANNOTATION";
      }
      // const drawingCanvas = this.$refs.drawingCanvas;
      const ctx = canvas.getContext("2d");
      // this.drawing.offsetX = $el.offsetLeft
      // this.drawing.offsetY = $el.offsetTop;

      const image = new Image();

      const drawing = this.drawing;
      const drawAnnotation = this.drawAnnotation;
      image.onload = function (e) {
        ctx.canvas.width = image.width;
        ctx.canvas.height = image.height;
        drawingCanvas.width = image.width;
        drawingCanvas.height = image.height;
        if (image.width < image.height) {
          analysis.clazz = "vertical";
        } else {
          analysis.clazz = "";
        }
        drawing.imageWidth = image.width;
        drawing.imageHeight = image.height;
        //console.log(`width : ${image.width}, height : ${image.height}`);
        // drawingCanvas.width = image.width;
        // drawingCanvas.height = image.height;
        // $el.width = image.width;
        // $el.height = image.height;
        ctx.drawImage(image, 0, 0);
        if (analysis.annotations != null) {
          analysis.annotations.forEach((label) => {
            // label.id, label.minX, label.maxX, label.minY, label.maxY
            drawAnnotation(label);
          });
        }
      };
      image.style.display = "inline";
      image.src = analysis.imageUrl;
    },
    handleMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
      const drawing = this.drawing;
      if (!drawing.isDrawing) {
        return;
      }
      // save the starting x/y of the rectangle
      const canvas = this.$refs.drawingCanvas;
      drawing.startX = parseInt((e.offsetX / canvas.clientWidth) * drawing.imageWidth);
      drawing.startY = parseInt((e.offsetY / canvas.clientHeight) * drawing.imageHeight);

      // set a flag indicating the drag has begun
      drawing.isStarted = true;
    },

    handleMouseMove(e) {
      const drawing = this.drawing;
      // if we're not dragging, just return
      if (!drawing.isStarted) {
        return;
      }

      // Put your mousemove stuff here
      const canvas = this.$refs.drawingCanvas;
      const ctx = canvas.getContext("2d");
      const lineWidth = this.getLineWidth();
      ctx.lineWidth = lineWidth;

      // get the current mouse position
      const mouseX = parseInt((e.offsetX / canvas.clientWidth) * drawing.imageWidth);
      const mouseY = parseInt((e.offsetY / canvas.clientHeight) * drawing.imageHeight);

      // clear the canvas
      ctx.clearRect(0, 0, drawing.imageWidth, drawing.imageHeight);

      // calculate the rectangle width/height based
      // on starting vs current mouse position
      drawing.width = mouseX - drawing.startX;
      drawing.height = mouseY - drawing.startY;

      // draw a new rect from the start position
      // to the current mouse position
      ctx.strokeRect(drawing.startX, drawing.startY, drawing.width, drawing.height);
    },

    handleMouseUp(e) {
      e.preventDefault();
      e.stopPropagation();

      const drawing = this.drawing;

      // the drag is over, clear the dragging flag
      drawing.isStarted = false;
    },

    async handleMouseOut(e) {
      e.preventDefault();
      e.stopPropagation();

      const drawing = this.drawing;

      // the drag is over, clear the dragging flag
      drawing.isStarted = false;
    },
  },
};
</script>
